import { render } from "./OliverChatBot.vue?vue&type=template&id=3c662f97&scoped=true"
import script from "./OliverChatBot.vue?vue&type=script&lang=js"
export * from "./OliverChatBot.vue?vue&type=script&lang=js"

import "./OliverChatBot.vue?vue&type=style&index=0&id=3c662f97&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c662f97"]])

export default __exports__